export default "__VITE_ASSET__qaCIyK$S__"